import './index.scss'
$(".section5 .drop li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section5 .pop-pic img").eq(index).addClass("active").siblings().removeClass("active");
})